import { css, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { registerAnalyticsAdapter } from 'components/shared/analytics/analytics.js'
import { createGa4Adapter } from 'components/shared/analytics/adapters/ga4/ga4-adapter.js'

@customElement('csc-initialize-analytics')
export class CSCInitializeAnalytics extends LitElement {
  static override styles = css`
    :host {
      display: contents;
    }
  `

  override connectedCallback(): void {
    super.connectedCallback()
    registerAnalyticsAdapter(createGa4Adapter())
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-initialize-analytics': CSCInitializeAnalytics
  }
}
